<template>
  <div>
    <DetailSheetHeader :title="$t('waypoint_dialog.options.waypoints')" subtitle="Your saved points on this map" />

    <div class="waypoint-options">
      <DetailSheetSection>
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.show_waypoints_on_map')"
          show-toggle
          :toggle-on="mapContainsWaypoints"
          @click="clickedShowWaypoints"
        />
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.add_new_waypoint')"
          icon="add_circle"
          @click="addNewWaypoint"
        />
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.view_all_waypoints')"
          icon="list"
          @click="clickViewAllWaypoints"
        />
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.view_waypoint_groups')"
          icon="folder"
          @click="viewWaypointGroupsClicked"
        />
        <DetailSheetActionRow
          :label="$t('waypoint_dialog.options.import_waypoints_from_gpx_file')"
          icon="upload"
          @click="triggerGPXFilePicker"
        />
      </DetailSheetSection>

      <input
        ref="gpxFileInput"
        class="d-none"
        type="file"
        id="file-input"
        title=""
        accept="application/gpx+xml"
        @change="handleGPXImportFile"
      >
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
// eslint-disable-next-line import/extensions,import/no-unresolved
import { mapState } from 'vuex';
import { WaypointOptionsDialogPages } from '../../../utils/models/WaypointOptionsDialogPages';
import { Modal } from "bootstrap";
import { GpxImportError, GpxImportErrorCode } from '../../../utils/helpers/gpxImportError';
import { gpxImportErrorMessage } from '../../../utils/helpers/gpxImportErrorMessage';
import DetailSheetActionRow from '../../../utils/shared_components/detail_sheet/DetailSheetActionRow.vue';
import DetailSheetHeader from '../../../utils/shared_components/detail_sheet/DetailSheetHeader.vue';
import DetailSheetSection from '../../../utils/shared_components/detail_sheet/DetailSheetSection.vue';

export default defineComponent({
  components: {
    DetailSheetActionRow,
    DetailSheetHeader,
    DetailSheetSection,
  },
  computed: Object.assign(mapState({
    mapContainsWaypoints: (state) => state.waypoints.mapContainsWaypoints,
  })),
  methods: {
    // The file input is hidden and driven from an action row, so every option in
    // the list is the same kind of control rather than one stray <label>.
    triggerGPXFilePicker() {
      this.$refs.gpxFileInput?.click();
    },
    handleGPXImportFile(event) {
      const file = event.target.files[0];
      const fileExtension = file.name.split('.').pop().toLowerCase();
      if (fileExtension === 'gpx') {
        // Handle the GPX file
        this.$store.dispatch('waypoints/importGPXFile', file);
      } else {
        alert(gpxImportErrorMessage(new GpxImportError(GpxImportErrorCode.NotGpx)));
      }
    },
    addNewWaypoint() {
      this.$store.commit('waypoints/toggleWaypointAddingNotification');
      const element = document.getElementById('waypoint-options-dialog');
      const modal = Modal.getInstance(element)
      modal.hide();
    },
    clickViewAllWaypoints() {
      this.$store.commit('waypoints/setTopPage', WaypointOptionsDialogPages.Waypoints);
    },
    clickedShowWaypoints() {
      if (this.mapContainsWaypoints) {
        this.$store.dispatch('waypoints/removeWaypointsFromMap');
      } else {
        this.$store.dispatch('waypoints/addWaypointsToMap');
      }
      const element = document.getElementById('waypoint-options-dialog');
      const modal = Modal.getInstance(element);
      modal.hide();
    },
    viewWaypointGroupsClicked() {
      this.$store.commit('waypoints/setTopPage', WaypointOptionsDialogPages.WaypointGroups);
    },
  },
});
</script>

<style scoped>
.waypoint-options {
  padding: 1rem;
}
</style>
